import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_PING, API_REFRESH, WHOAMI } from '../settings';
import { fetchData } from '../utils';
import { setNotification } from './notificationsSlice';
import { schemas } from './schemas';

export const getCurrentUser = createAsyncThunk(
    "getCurrentUser",
    async (arg, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(WHOAMI, {}, schemas.CURRENT_USER);
            return Object.values(response.entities.users)[0] || { fullName: "Unknown User" }
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        }
    },
    {
        condition: (arg, { getState }) => {
            const { user } = getState();
            return user.requesting;
        }
    }
);

export const pingServer = createAsyncThunk(
    "pingServer",
    async (arg, { dispatch }) => {
        try {
            fetchData(API_PING, {}, {});
        } catch (e) {
            dispatch(setNotification(e));
        }
    }
)

const user = createSlice({
    name: "user",
    initialState: {
        grants: {},
        requesting: true
    },
    reducers: {},
    extraReducers: {
        [getCurrentUser.pending]: (state, action) => {
            state.requesting = false;
        },
        [getCurrentUser.fulfilled]: (state, action) => {
            state.grants = action.payload;
            state.requesting = true;
        },
        [getCurrentUser.rejected]: (state, action) => {
            state.grants = action.payload;
            state.requesting = true;
        }
    }
});

export default user.reducer;